import React from 'react'
import { TableWebsocket } from './websocket'
import { withRouter } from 'react-router-dom'
import Spinner from '../../common/spinner'
import { fromJS, is } from 'immutable'
import Card from './card'
import Hand from './hand'
import Player from './player'
import HealthSelection from './healthSelection'
import Trick from './trick'
import TakePovertySelection from './takePovertySelection'
import PlayerMenu from './menu/playerMenu'
import EventMessage from './eventMessage'
import RoundResult from './roundResult'

class TableComponent extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            table: null,
            contentHeight: null,
            contentWidth: null,
            highlightedCards: fromJS({})
        }
        window.addEventListener("keydown", e => {
            if (e && e.key == "Tab") {
                e.preventDefault()
                e.stopPropagation()
                return true
            }
        })
    }

    componentDidMount()
    {
        this._ws = new TableWebsocket(
            this.props.match.params.code,
            this.props.match.params.playerKey,
            this.props.history,
            this.onMessage.bind(this)
        )
    }

    onMessage(msg)
    {
        const table = this.state.table
        switch(msg.type)
        {
        case "THROWN":
            const playerName = msg.tableOutline.players.find(p => p.id === msg.playerId).name
            getDialog().text(Messages("game.thrown.description", playerName, msg.nineCount));
            this.setState({ table: fromJS(msg.tableOutline) })
            break;
        case "GAME_MODE_SELECTED":
            let text;
            let winningPlayerName = msg.tableOutline.players.find(p => p.id === msg.playerId).name
            if (msg.bid === "HEALTHY") {
                text = Messages("game.bid.result.healthy");
            } else if (msg.bid.startsWith("MARRIAGE")) {
                text = Messages("game.bid.result.marriage", winningPlayerName);
            } else if (msg.bid === "POVERTY") {
                text = Messages("game.bid.result.poverty", winningPlayerName);
            } else if (msg.bid === "FLESHLESS" || msg.bid.includes("SOLO")) {
                text = Messages("game.bid.result.solo", winningPlayerName, Messages("game.bid." + msg.bid.toLowerCase().replace(/_/g, "-")));
            }

            if (text) {
                createEventMessage().show(text)
            }
            break;
        case "SPECIAL_EVENT":
            if (msg.specialEvent === "DOPPELKOPF") {
                createEventMessage().show(Messages("game.doppelkopf"))
            }
            break;
        case "REVEAL_SILENT_MARRIAGE":
            const silentMarriagePlayerName = msg.tableOutline.players.find(p => p.id === msg.playerId).name
            createEventMessage().show(Messages("table.reveal-silent-marriage", silentMarriagePlayerName))
            break;
        case "MARRIAGE_DECISION":
            let marriagePlayerName = msg.tableOutline.players.find(p => p.id === msg.marriagePlayerId)
            if (marriagePlayerName != null) {
                marriagePlayerName = marriagePlayerName.name
            }
            let partnerPlayerName = msg.tableOutline.players.find(p => p.id === msg.partnerPlayerId)
            if (partnerPlayerName != null) {
                partnerPlayerName = partnerPlayerName.name
            }
            createEventMessage().show(Messages("table.marriage." + (partnerPlayerName ? "married" : "solo"), marriagePlayerName, partnerPlayerName))
            break;
        case "POVERTY_DECISION":
            let povertyPlayerName = msg.tableOutline.players.find(p => p.id === msg.povertyPlayerId)
            if (povertyPlayerName != null) {
                povertyPlayerName = povertyPlayerName.name
            }
            let povertyPartnerPlayerName = msg.tableOutline.players.find(p => p.id === msg.partnerPlayerId)
            if (povertyPartnerPlayerName != null) {
                povertyPartnerPlayerName = povertyPartnerPlayerName.name
            }
            createEventMessage().show(Messages("table.poverty.selected", povertyPartnerPlayerName, povertyPlayerName))
            break;
        case "CARD_PLAYED":
            const highlightedCards = [msg.tableOutline.ownId, msg.tableOutline.spectatingId].includes(msg.playerId) ? fromJS({}) : this.state.highlightedCards
            this.setState({ table: fromJS(msg.tableOutline).set("_trickWinningPlayerId", msg.winningPlayerId), highlightedCards: highlightedCards })
            break;
        case "PLAYER_CHAT":
            window.postMessage("--dk-chat:" + JSON.stringify(msg))
            this.setState({ table: fromJS(msg.tableOutline) })
            break;
        case "NOTIFY_HOVER_CARD":
            this.setState({ highlightedCards: this.state.highlightedCards.set(msg.playerId, msg.idx) })
            break;
        default:
            if (table && msg.tableOutline && !is(fromJS(msg.tableOutline.spectatorConfig.blacklistedPlayers), table.getIn([ "spectatorConfig", "blacklistedPlayers" ]))) {
                this.setState({ table: fromJS(msg.tableOutline), highlightedCards: fromJS({}) })
            } else {
                this.setState({ table: fromJS(msg.tableOutline) })
            }
            break;   
        }
    }

    isOnTurn(state = this.state)
    {
        const table = state.table
        const playerSelf = table.get("players").filter(p => p.get("id") === table.get("ownId")).get(0)
        return table.get("activePlayerIdx") === playerSelf.get("idx")
    }

    render()
    {
        const table = this.state.table
        if (table) {
            const playerSelf = table.get("players").filter(p => p.get("id") === table.get("ownId")).get(0)
            const activePlayerIdx = table.get("activePlayerIdx")
            const isOwnTurn = activePlayerIdx === playerSelf.get("idx")
            const isPlaying = playerSelf && playerSelf.get("turnIdx") != null
            const shownPlayersByIndex = table.get("players").sort((a, b) => {
                const pivot = table.get("players").find(p => p.get("id") === table.get("spectatingId")) || playerSelf
                const newIdx = idx => (idx + (table.get("players").size - pivot.get("idx"))) % table.get("players").size
                return newIdx(a.get("idx")) - newIdx(b.get("idx"))
            }).filter(p => p.get("turnIdx") != null)
            const playerPositions = fromJS({
                left: shownPlayersByIndex.get(1),
                top: shownPlayersByIndex.get(2),
                right: shownPlayersByIndex.get(3),
                bot: shownPlayersByIndex.get(0)
            })

            let tableCenter
            if (table.get("players").size < 4) {
                tableCenter = (
                    <div className="dk-box code-box">
                        <div>{ Messages("table.code") }</div>
                        <div className="code">{ table.get("code") }</div>
                    </div>
                )
            } else if (table.get("status") === "HEALTH") {
                tableCenter = isPlaying ? (
                    <HealthSelection
                        send={ this._ws.send }
                        table={ table }
                        isOwnTurn={ isOwnTurn }
                    />
                ) : null
            } else if (table.get("status") === "POVERTY") {
                tableCenter = isPlaying ? (
                    <TakePovertySelection
                        send={ this._ws.send }
                        table={ table }
                        isOwnTurn={ isOwnTurn }
                    />
                ) : null
            } else if (table.get("status") === "ACTIVE") {
                tableCenter = (
                    <Trick
                        table={ table }
                        parentHeight={ this.state.contentHeight }
                        parentWidth={ this.state.contentWidth }
                        playerPositions={ playerPositions }
                        isPlaying={ isPlaying }
                    />
                )
            } else if ([ "END_OF_ROUND", "FINISHED" ].includes(table.get("status"))) {
                tableCenter = (
                    <RoundResult
                        send={ this._ws.send }
                        table={ table }
                    />
                )
            }

            let spectatorBadge = (isPlaying || table.get("spectatingId")) ? null : (
                <div className="spectator-badge dk-box">{ Messages("table.spectating") }</div>
            )

            return (
                <div className="game-table" ref={ ref => {
                    this._element = ref; if (ref && (this.state.contentHeight != ref.clientHeight || this.state.contentWidth != ref.clientWidth))
                    {
                        this.setState({ contentHeight: ref.clientHeight, contentWidth: ref.clientWidth })
                    }
                }}>
                    <div className="table-upper">
                        <div className="player-container">
                            <Player 
                                position="left"
                                active={ playerPositions.get("left") && activePlayerIdx === playerPositions.get("left").get("idx") }
                                outline={ playerPositions.get("left") }
                                table={ this.state.table }
                            />
                            <Player 
                                position="top"
                                active={ playerPositions.get("top") && activePlayerIdx === playerPositions.get("top").get("idx") }
                                outline={ playerPositions.get("top") }
                                table={ this.state.table }
                            />
                            <Player
                                position="right"
                                active={ playerPositions.get("right") && activePlayerIdx === playerPositions.get("right").get("idx") }
                                outline={ playerPositions.get("right") }
                                table={ this.state.table }
                            />
                        </div>
                    </div>
                    <Player 
                        position="self"
                        active={ activePlayerIdx === playerSelf.get("idx") }
                        className="player-self" 
                        outline={ playerPositions.get("bot") }
                        table={ this.state.table }
                    />
                    <PlayerMenu
                        table={ table }
                        send={ this._ws.send }
                        isOwnTurn={ isOwnTurn }
                    />
                    <div className="table-center">
                        { tableCenter }
                    </div>
                    <div className="table-lower">
                        <Hand
                            table={ table }
                            send={ this._ws.send }
                            hand={ table.get("hand") }
                            highlightedCards={ this.state.highlightedCards }
                            parentHeight={ this.state.contentHeight }
                            parentWidth={ this.state.contentWidth }
                            isOwnTurn={ isOwnTurn }
                            isPlaying={ isPlaying }
                        />
                        { spectatorBadge }
                    </div>
                    <EventMessage
                        publish={ ref => window.createEventMessage = () => ref }
                    />
                </div>
            )
        }

        return (
            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Spinner large withBackground />
            </div>
        )
    }

}

export const Table = withRouter(TableComponent)

export default Table